module.exports = __webpack_public_path__ + "media/icons/arrow-narrow-up-07cc88f5.svg";